import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { $axios } from "@bloglovin/vue-framework";

export const EventCardElementMixin = {
  extends: DynamicElementMixin,
  entityStore: SmartFeedEngine.getEntityPiniaStore("event"),
  methods: {
    getExampleEntity() {
      return {
        "eventId": 1,
        "publicationId": 42,
        "title": "Test Event",
        "description": "Test Description",
        "imageUrl": "",
        "metadata": "{}",
        "meetingLink": "https://zoom.us/j/1234567890",
        "location": "1234 Example St, Brooklyn NY",
        "eventType": "webinar",
        "allowTicketPurchase": false,
        "ticketPrice": 0,
        "status": "active",
        "eventTimestamp": 1733412192,
        "startTimestamp": 1733412192,
        "endTimestamp": 1733415792,
        "recurringFrequency": 3,
        "recurrenceSummary": "Weekly on Tuesday",
        "recurringStartTimestamp": 1733412192,
        "recurringEndTimestamp": 1765012192,
        "occurrenceNumber": 1,
        "isRecurringOccurrence": false,
        "date": "2025-01-1st",
        "timestampCreated": 1733412192,
        "timestampUpdated": 1733412192,
      };
    },
    async getRealEntity() {
      if (this.entityId.includes("_")) {
        const [eventId, occurrenceTimestamp] = `${this.entityId}`.split("_");
        const response = await $axios.get(`/event/${eventId}`, {
          params: {
            timestamp: occurrenceTimestamp,
          },
        });

        return response.data;
      }
      return await new SmartFeedEngine().getEntity(
        "event",
        this.entityId,
      );
    },
  },
};
